if (!customElements.get('variant-picker')) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', this.onVariantChange.bind(this));
      this.updateOptions();
      this.updateMasterId();
      this.initializePrices();
    }

    initializePrices() {
      const comparePrice = document.querySelector('[data-compare-price]');
      const priceElement = document.querySelector('[data-product-price]');
      const priceOffContainer = document.querySelector('[data-price-off]');

      if (comparePrice) {
        const currentPrice = this.currentVariant?.price || 0;
        const compareAtPrice = this.currentVariant?.compare_at_price || 0;
        
        if (!compareAtPrice || compareAtPrice <= 0 || compareAtPrice <= currentPrice) {
          comparePrice.style.display = 'none';
          comparePrice.innerHTML = '';
          priceElement?.classList.remove('product__price--sale');
        }
      }

      if (priceOffContainer) {
        priceOffContainer.classList.add('hidden');
      }
    }

    onVariantChange(event) {
      const selectedOptions = [];
      this.querySelectorAll('fieldset').forEach(fieldset => {
        const checkedInput = fieldset.querySelector('input:checked');
        if (checkedInput) {
          selectedOptions.push(checkedInput.value);
        }
      });
      
      const variants = this.getVariantData();
      this.currentVariant = variants.find((variant) => {
        return JSON.stringify(variant.options) === JSON.stringify(selectedOptions);
      });

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo();
      }
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      const selectedOptions = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input:checked')).map(input => input.value)[0];
      });
      this.options = selectedOptions;
    }

    updateMasterId() {
      const variants = this.getVariantData();
      this.currentVariant = variants.find((variant) => {
        return variant.options.every((option, index) => option === this.options[index]);
      });
    }

    updateMedia() {
      if (!this.currentVariant || !this.currentVariant?.featured_media) return;
      const newMedia = document.querySelector(
        `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
      );
      if (!newMedia) return;
      const parent = newMedia.parentElement;
      parent.prepend(newMedia);
      window.setTimeout(() => { parent.scroll(0, 0); });
    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
      
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        if (input) {
          input.value = this.currentVariant.id;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('pickup-availability');
      if (!pickUpAvailability) return;

      if (this.currentVariant?.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    renderProductInfo() {
      if (!this.currentVariant) return;
      
      try {
        const priceElement = document.querySelector('[data-product-price]');
        if (priceElement) {
          const price = this.currentVariant.price/100;
          const formattedPrice = Shopify.currency.active === 'EUR' 
            ? `${price.toFixed(2).replace('.', ',')} €`
            : `${Shopify.currency.active} ${price.toFixed(2).replace('.', ',')}`;
          priceElement.innerHTML = formattedPrice;
        }
        const comparePriceElement = document.querySelector('[data-compare-price]');
        if (comparePriceElement && this.currentVariant.compare_at_price) {
          const comparePrice = this.currentVariant.compare_at_price/100;
          const formattedComparePrice = Shopify.currency.active === 'EUR'
            ? `${comparePrice.toFixed(2).replace('.', ',')} €`
            : `${Shopify.currency.active} ${comparePrice.toFixed(2).replace('.', ',')}`;
          comparePriceElement.innerHTML = formattedComparePrice;
          comparePriceElement.style.display = 'inline-block';
        } else if (comparePriceElement) {
          comparePriceElement.style.display = 'none';
        }

        const priceOffContainer = document.querySelector('[data-price-off]');
        const priceOffAmount = document.querySelector('[data-price-off-amount]');
        if (priceOffContainer && priceOffAmount && 
            this.currentVariant.compare_at_price > this.currentVariant.price) {
          const savings = this.currentVariant.compare_at_price - this.currentVariant.price;
          const formattedSavings = new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency: Shopify.currency.active,
            minimumFractionDigits: 2
          }).format(savings/100);
          
          priceOffAmount.innerHTML = formattedSavings;
          priceOffContainer.classList.remove('hidden');
        } else if (priceOffContainer) {
          priceOffContainer.classList.add('hidden');
        }

      } catch (error) {
        console.error('Error rendering product info:', error);
      }
    }

    toggleAddButton(disable = true, text, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;
      const addButton = productForm.querySelector('[name="add"]');
      const addButtonText = productForm.querySelector('[name="add"] > span');
      if (!addButton) return;

      if (disable) {
        addButton.setAttribute('disabled', 'disabled');
        if (text) addButtonText.textContent = text;
      } else {
        addButton.removeAttribute('disabled');
        addButtonText.textContent = window.variantStrings.addToCart;
      }

      if (!modifyClass) return;
    }

    setUnavailable() {
      const button = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
      const addButtonText = button?.querySelector('span');
      const price = document.getElementById(`price-${this.dataset.section}`);
      const inventory = document.getElementById(`inventory-${this.dataset.section}`);
      const sku = document.getElementById(`sku-${this.dataset.section}`);

      if (!addButtonText) return;

      addButtonText.textContent = window.variantStrings.unavailable;
      if (price) price.classList.add('visibility-hidden');
      if (inventory) inventory.classList.add('visibility-hidden');
      if (sku) sku.classList.add('visibility-hidden');
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]')?.textContent);
      return this.variantData;
    }
  }

  customElements.define('variant-picker', VariantPicker);
}

document.addEventListener('DOMContentLoaded', function() {
  const variantPicker = document.querySelector('variant-picker');
  if (variantPicker) {
    variantPicker.updateOptions();
    variantPicker.updateMasterId();
    variantPicker.initializePrices();
  }

  const comparePrice = document.querySelector('[data-compare-price]');
  const priceElement = document.querySelector('[data-product-price]');
  const priceOffContainer = document.querySelector('[data-price-off]');

  if (comparePrice) {
    const currentPrice = parseFloat(priceElement?.innerHTML?.replace(/[^0-9,.]/g, '').replace(',', '.')) || 0;
    const comparePriceValue = parseFloat(comparePrice?.innerHTML?.replace(/[^0-9,.]/g, '').replace(',', '.')) || 0;

    if (!comparePriceValue || comparePriceValue <= 0 || comparePriceValue <= currentPrice) {
      comparePrice.style.display = 'none';
      comparePrice.innerHTML = '';
      priceElement?.classList.remove('product__price--sale');
    }
  }

  if (priceOffContainer) {
    priceOffContainer.classList.add('hidden');
  }
});
